(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["danny-product-buster"] && !Shopify.designMode) return;
  try {
    const initializeDannyProductBuster = () => {
    const product = document.querySelector('.product');
    const stickyBar = document.querySelector('[data-danny-mobile-buybar]');
    const stickyButton = stickyBar?.querySelector('[data-danny-sticky-submit]');
    const stickyPrice = stickyBar?.querySelector('[data-danny-sticky-price]');
    const mainButton = product?.querySelector('.product-form__submit');
    const priceContainer = product?.querySelector('[id^="price-"]');
    const description = product?.querySelector('.product__description');
    const descriptionLabels = document.querySelector('[data-danny-description-labels]');

    if (!product || !stickyBar || !stickyButton || !mainButton) return;

    if (stickyBar.parentElement !== document.body) {
      document.body.append(stickyBar);
    }

    const normalizeText = (value) => value
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase();
    let discountWidget;
    let discountOfferOpened = false;

    try {
      discountOfferOpened = window.sessionStorage.getItem('dannyExitDiscountShown') === 'true';
    } catch (error) {
      discountOfferOpened = false;
    }

    const findDiscountWidget = () => {
      for (const element of document.querySelectorAll('body *')) {
        const directText = [...element.childNodes]
          .filter((node) => node.nodeType === Node.TEXT_NODE)
          .map((node) => node.textContent)
          .join(' ');
        const shadowText = element.shadowRoot?.textContent || '';
        if (normalizeText(shadowText).includes('10% znizki')) {
          return {
            container: element,
            trigger: element.shadowRoot?.querySelector('button')
          };
        }

        if (!normalizeText(directText).includes('10% znizki')) continue;

        let overlay = element;
        for (let level = 0; level < 7 && overlay.parentElement; level += 1) {
          if (window.getComputedStyle(overlay).position === 'fixed') break;
          overlay = overlay.parentElement;
        }

        const container = window.getComputedStyle(overlay).position === 'fixed' ? overlay : element;
        return {
          container,
          trigger: element.closest('button') || container.querySelector('button')
        };
      }

      return undefined;
    };

    const maintainOverlayVisibility = () => {
      if (window.matchMedia('(max-width: 749px)').matches) {
        document.querySelectorAll('.phone-button-wrapper, shopify-chat').forEach((element) => {
          element.style.setProperty('display', 'none', 'important');
        });
      }

      if (!discountWidget || !document.contains(discountWidget.container)) {
        discountWidget = findDiscountWidget();
      }

      const isMobileViewport = window.matchMedia('(max-width: 749px)').matches;
      if (discountWidget && (isMobileViewport || !discountOfferOpened)) {
        discountWidget.container.style.setProperty('display', 'none', 'important');
      }
    };

    maintainOverlayVisibility();
    new MutationObserver(maintainOverlayVisibility).observe(document.body, { childList: true, subtree: true });
    let discountCheckCount = 0;
    const discountCheckTimer = window.setInterval(() => {
      maintainOverlayVisibility();
      discountCheckCount += 1;
      if (discountWidget || discountCheckCount >= 180) window.clearInterval(discountCheckTimer);
    }, 1000);

    const openDiscountOffer = () => {
      if (discountOfferOpened) return;
      discountWidget = findDiscountWidget();
      if (!discountWidget?.trigger) return;

      discountOfferOpened = true;
      discountWidget.container.style.removeProperty('display');
      discountWidget.trigger.click();
      try {
        window.sessionStorage.setItem('dannyExitDiscountShown', 'true');
      } catch (error) {
        discountOfferOpened = true;
      }
    };

    document.addEventListener('mouseout', (event) => {
      if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
      if (event.clientY <= 0 && !event.relatedTarget) openDiscountOffer();
    });

    stickyButton.addEventListener('click', () => {
      if (mainButton.disabled) {
        product.querySelector('variant-selects, variant-radios, .product-form__input')?.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }
      mainButton.click();
    });

    const synchronizeButton = () => {
      stickyButton.disabled = mainButton.disabled;
      stickyButton.textContent = mainButton.textContent.trim();
    };

    const synchronizePrice = () => {
      if (!stickyPrice || !priceContainer) return;
      const price = priceContainer.querySelector('.price');
      const priceElement = price?.classList.contains('price--on-sale')
        ? price.querySelector('.price-item--sale')
        : price?.querySelector('.price-item--regular');
      const priceText = priceElement?.textContent.trim();
      if (priceText) stickyPrice.textContent = priceText;
    };

    synchronizeButton();
    synchronizePrice();
    new MutationObserver(synchronizeButton).observe(mainButton, { attributes: true, childList: true, subtree: true });
    if (priceContainer) {
      new MutationObserver(synchronizePrice).observe(priceContainer, { attributes: true, childList: true, subtree: true });
    }

    if (description && description.scrollHeight > 520 && !document.querySelector('.danny-description-toggle')) {
      const toggle = document.createElement('button');
      toggle.type = 'button';
      toggle.className = 'danny-description-toggle';
      toggle.textContent = descriptionLabels?.dataset.showLabel || '';
      toggle.setAttribute('aria-expanded', 'false');
      description.after(toggle);
      toggle.addEventListener('click', () => {
        const expanded = description.classList.toggle('danny-description-expanded');
        toggle.setAttribute('aria-expanded', String(expanded));
        toggle.textContent = expanded
          ? descriptionLabels?.dataset.hideLabel || ''
          : descriptionLabels?.dataset.showLabel || '';
      });
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeDannyProductBuster, { once: true });
  } else {
    initializeDannyProductBuster();
  }
  } catch(e) { console.error(e); }
})();

})();
